<template>
  <v-app id="inspire"> 
     <v-app-bar
    id="app-bar"
    fixed
    clipped-left
    app
    color="darken-3"
    dark 
    dense
    height="64"  
  > 
    <v-app-bar-nav-icon 
      medium
      class="pl-10"
      color="white darken-1" 
    ><v-img src="/ntsa.png" height="60" width="100"/></v-app-bar-nav-icon>   

    <v-spacer></v-spacer>   

    <v-btn
      class="ml-2"
      color="white"
      @click="logout" 
      min-width="0"
      text
    >
      <v-icon medium>mdi-exit-to-app</v-icon> Sign Out
    </v-btn> 
    <br />
  </v-app-bar>

  <div style="min-height:610px; background: #eee" class="mobile_content">
         
        <v-row>
          <v-col cols="3"></v-col>
          <v-col>
            <v-text-field
            v-model="search" 
            color="green"
            flat
            solo-inverted
            label="Search Vehicle"
            class="hidden-sm-and-down pt-5 mt-2"  
            prepend-inner-icon="mdi-magnify" 
          ></v-text-field>    
          </v-col>
          <v-col cols="1"><v-btn class="mt-8" @click="available_data" :loading="loading"><v-icon>mdi-magnify</v-icon></v-btn></v-col>
          <v-col cols="3"></v-col>
        </v-row>

         <Notification></Notification>
 
         <v-row>
           <v-col>
             <v-simple-table class="pa-1">
               <thead> <tr><th>Owner Details</th></tr> </thead>
               <tbody>
                 <tr><td>Name  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.owner}}</b></td></tr>
                 <tr><td>ID No. &nbsp;&nbsp;&nbsp;&nbsp; <b>{{  movements.id}}</b></td></tr>
                 <tr><td>Phone No. &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.phone}}</b></td></tr> 
               </tbody>
             </v-simple-table> 
           </v-col>

           <v-col>
             <v-simple-table class="pa-1">
               <thead> <tr><th>Asset Details</th></tr> </thead>
               <tbody>
                 <tr><td>Registration No.  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.regno}}</b></td></tr>
                 <tr><td>Chassis No.  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.chassis}}</b></td></tr>
                 <tr><td>Limiter Type  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.limitertype}}</b></td></tr> 
                 <tr><td>Limiter Serial &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.limiterserial}}</b></td></tr> 
                 <tr><td>Make &amp; Model   &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.make}}</b></td></tr> 
               </tbody>
             </v-simple-table>  
           </v-col>

           <v-col>
             <v-simple-table class="pa-1">
               <thead> <tr><th>Fitting Company</th></tr> </thead>
               <tbody>
                 <tr><td>Name &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.fittingcenter}}</b></td></tr>
                 <tr><td>Business Reg No. &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.bsnregno}}</b></td></tr>
                 <tr><td>Phone No.&nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentphoneno}}</b></td></tr> 
                 <tr><td>Email&nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentemail}}</b></td></tr> 
               </tbody>
             </v-simple-table>  
           </v-col>

           <v-col>
             <v-simple-table class="pa-1" dense style="font-size: 9px">
               <thead> <tr><th>Fitting Agent Details</th></tr> </thead>
               <tbody>
                 <tr><td>Name  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.fittingcenter}}</b></td></tr>
                 <tr><td>ID Number  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentid}}</b></td></tr>
                 <tr><td>Phone Number  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentphoneno}}</b></td></tr> 
                 <tr><td>Date Of Fitting  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.installdate}}</b></td></tr> 
                 <tr><td>Certificate Number  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.serialno}}</b></td></tr> 
                 <tr><td>Name &amp; Location of Station  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.location}}</b></td></tr> 
               </tbody>
             </v-simple-table>  
           </v-col> 
         </v-row> 
        <br>  
        <v-row>
          <v-col> 
              <v-btn-toggle v-model="toggle_none" background-color="primary"> 
                <v-btn value="current">Current</v-btn>
                <v-btn value="overspeed">Overspeed</v-btn>
                <v-btn value="violations">Violations</v-btn> 
              </v-btn-toggle> 
          </v-col> 
          <v-col cols="4">
            <v-btn v-if="recs_loading"  icon background-color="success" class="spin-animation">
              <v-icon>mdi-cached</v-icon>
            </v-btn>
          </v-col>
          <v-col> 
            <v-combobox
              v-model="selectedDownload"
              :items="downloadOptions"
              label="Export Options" 
              outlined
              dense
              @change="handleDownload"
            ></v-combobox>  
          </v-col>
        </v-row>

        <v-simple-table class="pa-1">
               <thead> <tr> <th>Date</th>  <th>Speed</th> <th>Longitude</th> <th>Latitude</th> </tr> </thead>
               <tbody>
                 <tr v-if="recs_loading"><td colspan="5">Populating records please wait..</td> </tr> 
                 <tr v-if="!recs_loading && recs.length==0"><td colspan="5">No records found.</td> </tr> 
                 <tr v-for="(drive,index)  in recs" :key="index">
                   <td>{{drive.dt_tracker}}</td>  <td>{{drive.speed}}</td> <td>{{drive.lng}}</td> <td>{{drive.lat}}</td>
                 </tr>
               </tbody>
        </v-simple-table>  
  </div>  
  <Footer /> 
  </v-app>
</template>

<style scoped>
body {
  background: #eee;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  font-size: 12px;
}

.theme--light.v-application{
  background: #eee
}

.mobile_content{
  margin-left: 0  !important;
  padding: 3px !important;
  padding-top: 63px !important;
} 

.spin-animation {
  animation: spin 1s infinite linear;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

</style>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logoImage from "@/assets/kensrin.png";
import common from "./mixins/common";
export default {
  name: "Ntsa",
  components: { 
    Footer: () => import("./components/Footer"),
    Notification: () => import("./components/Notification")
  }, 
  mixins: [common], 
  methods: {  
    logout() {
      this.$store.dispatch("logout");
    }, 

    handleDownload(){ 
      if(this.selectedDownload == "current")
        this.generatePDF(); 
      else {
        this.isReporting = true;
        this.checkdata();
      }  
    },

    available_data() {
      if(this.search==''){
         this.setNotification(
              "error",
              "Search for an asset to continue."
            );
        return;
      }

      this.loading = true;
      this.http_connect_node("/sg",{ token: this.check_token(), country: process.env.VUE_APP_COUNTRY, regno: this.search  })
        .then(res => {  
          if (res.status == 200) { 
            if(res.data.payload.sg.length > 0 ){
              this.movements = res.data.payload.sg[0];  
              this.checkdata();
            } else 
             this.setNotification(
              "error",
              "Asset is not available."
            );
          } else {
            this.setNotification(
              "error",
              "Failed to fetch records please try again."
            );
            this.loading = false;
          }
          this.loading = false;
        })
        .catch(err => {
          this.setNotification("error", "Failed to fetch vehicle details.");
          this.loading = false;
        });
    },
 
    checkdata(){   
      this.recs_loading = true;
      this.http_connect_node("/get_route_ntsa", {
        token: this.check_token(), 
        speed: (this.toggle_none=="overspeed"? '80' : (this.toggle_none=="violations"? 'violations' : '')),
        hours: (this.toggle_none=="current" || this.toggle_none=="violations" || this.toggle_none=="overspeed") ? '1' : (this.selectedDownload=="last6"? '6' : (this.selectedDownload=="last72"? '72' : '')),
        imei:  this.movements.imei
      }).then(res => {  
        this.recs = res.data;
        this.recs_loading = false; 
        this.initial_load = true;
        this.last_load_complete = true; 

        if(this.isReporting){ 
          this.generatePDF();
          this.isReporting = false;
        }

        if(this.check_token()!==null){
          window.setInterval(() => { 
           if(this.last_load_complete){
             this.last_load_complete = false;
              this.checkdata();
           }
          }, 120000);  
        } 
         
      });  
    }, 
    generatePDF() {
      const doc = new jsPDF();
      const leftMargin = 15;
      let y = 15; // Starting vertical position 
      // 1. ADD LOGO
      // Parameters: Image, Format, X, Y, Width, Height
      // Adjust width/height to maintain your logo's aspect ratio
      doc.addImage(logoImage, "PNG", leftMargin, y, 20, 20); 
      // Move Y down so text doesn't overlap the logo
      y += 18;

      // Helper for Section Headers
      const addSection = (title) => {
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setFillColor(240, 240, 240); // Light gray background
        doc.rect(leftMargin, y, 180, 8, "F");
        doc.text(title, leftMargin + 2, y + 6);
        y += 15;
      };

      // Helper for Data Rows
      const addRow = (label1, value1, label2, value2) => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(`${label1} : `, leftMargin, y);
        doc.setFont("helvetica", "normal");
        doc.text(`${value1}`, leftMargin + 35, y);

        if (label2) {
          doc.setFont("helvetica", "bold");
          doc.text(`${label2} : `, leftMargin + 100, y);
          doc.setFont("helvetica", "normal");
          doc.text(`${value2}`, leftMargin + 135, y);
        }
        y += 9;
      };

      // --- PAGE 1 CONTENT ---
      doc.setFontSize(14);
      doc.text("Installation Details", 105, y, { align: "center" });
      y += 15;

      addSection("Owner Details");
      addRow("Owner Name", this.movements.owner, "Owner ID", this.movements.id);
      addRow("Owner Phone", this.movements.phone);
      y += 5;

      addSection("Asset Details");
      addRow("Registration", this.movements.regno, "Chassis", this.movements.chassis);
      addRow("Make & Model", this.movements.make, "Limiter Type", this.movements.limitertype);
      addRow("Limiter Serial", this.movements.limiterserial);
      y += 5;

      addSection("Fitting Company");
      addRow("Name", this.movements.fittingcenter, "Business Reg No.", this.movements.bsnregno || '-');
      addRow("Phone No.", this.movements.agentphoneno, "Email", this.movements.agentemail);
      y += 5;

      addSection("Fitting Agent Details");
      addRow("Name", this.movements.fittingcenter, "ID Number", this.movements.agentid);
      addRow("Phone Number", this.movements.agentphoneno, "Date Of Fitting", this.movements.installdate);
      addRow("Certificate Number", this.movements.serialno, "Location", this.movements.location);
      y += 5;

      // addSection("Installation Details");
      // addRow("Fitting Date", this.movements.fittingDate, "Certificate No.", this.movements.certificateNo);
      // addRow("Fitting Location", this.movements.fittingLocation);

      // --- PAGE 2 CONTENT ---
      doc.addPage();
      doc.setFont("helvetica", "bold");
      doc.text("Speed Records", 15, 20); 
      autoTable(doc,{
        startY: 25,
        head: [['Date', 'Speed', 'Longitude', 'Latitude']],
        body: this.recs.map(rec => [rec.dt_tracker, rec.speed + " km/h", rec.lng, rec.lat]),
        theme: 'striped',
        headStyles: { fillColor: [51, 51, 51] }
      });

      // Save the PDF
      doc.save(this.search +"_report.pdf");
    }
  },

  watch: {
        toggle_none: function () {
            if(this.initial_load && this.search !='')
              this.checkdata();
        },
  },
 
  data: () => ({
    loading: false,
    recs_loading: false,
    isReporting: false,
    search: '',
    movements: [],
    recs: [],
    toggle_none: 'current',
    initial_load: false,
    last_load_complete: false,
    downloadOptions: [
      { text: "Last 1 Hour", value: "lastone" },
      { text: "Last 6 Hour", value: "last6" },
      { text: "Last 72 Hour", value: "last72" },
      { text: "Download Displayed", value: "current" }, 
    ],
    selectedDownload: ""
  })
};
</script>